import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// ---- Ingredients (per restaurant) -----------------------------------------

export const listIngredients = async (restaurantId) => {
  const { data } = await axios.get(`${API_URL}/users/restaurant/${restaurantId}/ingredients/`);
  return data?.results || [];
};

// Allergens are ingredients flagged is_allergen — the single allergen source.
export const listAllergenIngredients = async (restaurantId) => {
  const { data } = await axios.get(
    `${API_URL}/users/restaurant/${restaurantId}/ingredients/`,
    { params: { is_allergen: 'true' } },
  );
  return data?.results || [];
};

export const createIngredient = async (restaurantId, payload) => {
  const { data } = await axios.post(`${API_URL}/users/restaurant/${restaurantId}/ingredients/`, payload);
  return data?.data;
};

export const updateIngredient = async (restaurantId, id, payload) => {
  const { data } = await axios.put(`${API_URL}/users/restaurant/${restaurantId}/ingredients/${id}/`, payload);
  return data?.data;
};

export const deleteIngredient = async (restaurantId, id) => {
  const { data } = await axios.delete(`${API_URL}/users/restaurant/${restaurantId}/ingredients/${id}/`);
  return data;
};
